module.exports = __webpack_public_path__ + "components/country-flag/static/er-d3558d565a8f59124efdfc9beb839884.svg";